<div class="field-header">
  <div class="field-label">
    <span class="label">{{ header }}</span>
    @if (required) {
      <span class="required">*</span>
    }
    @if (tooltip) {
      <img class="tooltip" pTooltip="{{ tooltip }}" escape src="./assets/svgs/question-mark.svg" />
    }
  </div>
  @if (description) {
    <div class="description">{{ description }}</div>
  }
</div>
<div class="field-input">
  <ng-content></ng-content>
</div>
